const SystemDataConstants = {
  SYSTEM_SET_LINKS: 'SYSTEM_SET_LINKS',
  SYSTEM_SET_BANNERS: 'SYSTEM_SET_BANNERS',
  SYSTEM_SET_BUSINESS_INFO: 'SYSTEM_SET_BUSINESS_INFO',
  SYSTEM_SET_CATEGORIES: 'SYSTEM_SET_CATEGORIES',
  SYSTEM_CLEAR_LINKS: 'SYSTEM_CLEAR_LINKS',
  SYSTEM_CLEAR_BANNERS: 'SYSTEM_CLEAR_BANNERS',
  SYSTEM_CLEAR_BUSINESS_INFO: 'SYSTEM_CLEAR_BUSINESS_INFO',
  UPDATE_SYSTEM_DATA: 'UPDATE_SYSTEM_DATA',
  SYSTEM_SET_MEDIA_REGISTRY: 'SYSTEM_SET_MEDIA_REGISTRY',
  SYSTEM_CLEAR_MEDIA_REGISTRY: 'SYSTEM_CLEAR_MEDIA_REGISTRY',
  SYSTEM_CLEAR_CATEGORIES: 'SYSTEM_CLEAR_CATEGORIES',
};

export default SystemDataConstants;